import React from "react"
import "./leaflet-indicator.scss"
import Icon from "../../atoms/Icon/Icon"

const LeafletIndicator = props => {
    const indicator = props.isMobile ? 
    {right: props.activeStep === 1 ? "80%" : props.activeStep === 2 ? "50%" : props.activeStep === 3 ? "15%" : "100%"}
    :
    {bottom: props.activeStep === 1 ? "80%" : props.activeStep === 2 ? "50%" : props.activeStep === 3 ? "15%" : "100%"};
    return (
        <div className={`f-leaflet-indicator-wrapper ${props.isMobile && 'f-leaflet-indicator-wrapper--mobile'}`}>
            <div className="f-leaflet-indicator" style={indicator} />
            <span className={`f-leaflet-indicator-step ${props.activeStep === 1 ? "f-leaflet-indicator-step--active" : (props.activeStep === 2 || props.activeStep === 3) ? "f-leaflet-indicator-step--success" : ""}`}>{ (props.activeStep === 2 || props.activeStep === 3) ? <Icon icon="icon-check white" tagtype="i" size="1"  /> : "1"}</span>
            <span className={`f-leaflet-indicator-step ${props.activeStep === 2 ? "f-leaflet-indicator-step--active" : props.activeStep === 3 ? "f-leaflet-indicator-step--success" : ""}`}>{ props.activeStep === 3 ? <Icon icon="icon-check white" tagtype="i" size="1"  /> : "2"}</span>
            <span className={`f-leaflet-indicator-step ${props.activeStep === 3 ? "f-leaflet-indicator-step--active" : ""}`}>3</span>
        </div>
        
    )
}

export default LeafletIndicator
